/**
 * Module dependencies.
 */

import { JSX } from 'react';
import { Link } from '../link/link';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  phone: string;
  style?: JSX.IntrinsicElements['a']['style'];
};

/**
 * Export `PhoneLink` component.
 */

export function PhoneLink({ className, phone, style }: Props): JSX.Element {
  return (
    <Link className={className} href={`tel:${phone}`} passHref style={style}>
      {phone}
    </Link>
  );
}
